import { Healing as StatusIcon, DirectionsBoat as TypeIcon } from '@mui/icons-material'
import { Datagrid, EditButton, List, SelectField, TextField, useRecordContext } from 'react-admin'
import {
  ChoiceFilter,
  CustomerTextField,
  ExpandBoat,
  FilterSidebar,
  LinkToRecord,
  NoResults,
} from '~/components'
import { boatSellers } from '~/helpers'
import { boatStatusChoices, boatTypeChoices } from '~/types/choices'

const BoatSellerField = ({ source }) => {
  const record = useRecordContext()
  const seller = boatSellers(record, source)[0]
  return seller ? (
    <span>
      <LinkToRecord resource='customers' record={seller} id='customer_id' disabled>
        <CustomerTextField source='customer.firstname' />
        <CustomerTextField source='customer.lastname' />
      </LinkToRecord>
    </span>
  ) : null
}

// The sidebar's choices; the empty list names those in effect.
const choiceFilters = [
  {
    source: 'status',
    label: 'resources.boats.fields.status',
    choices: boatStatusChoices,
    icon: <StatusIcon />,
  },
  {
    source: 'boat_type',
    label: 'resources.boats.fields.boat_type',
    choices: boatTypeChoices,
    icon: <TypeIcon />,
  },
]

const BoatList = (props) => (
  <List
    title='resources.boats.title'
    aside={
      <FilterSidebar search='model'>
        {choiceFilters.map((filter) => (
          <ChoiceFilter key={filter.source} {...filter} />
        ))}
      </FilterSidebar>
    }
    sort={{ field: 'model', order: 'ASC' }}
    {...props}
  >
    <Datagrid
      bulkActionButtons={false}
      expand={<ExpandBoat />}
      rowClick='show'
      empty={<NoResults filters={choiceFilters} search='model' />}
    >
      <TextField source='model' label='resources.boats.fields.model' />
      <BoatSellerField
        source='boat_customer'
        label='resources.relations.types.seller'
        sortable={false}
      />
      <SelectField
        source='status'
        label='resources.boats.fields.status'
        choices={boatStatusChoices}
      />
      <EditButton />
    </Datagrid>
  </List>
)

export default BoatList
